import React, { useState } from 'react';
import Modal from '../../Modal/Modal';
import { BookCollaborationIntro } from './Intro/BookCollaborationIntro';

interface CollaborationIntroModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: (dontShowAgain: boolean) => void;
}

const CollaborationIntroModal: React.FC<CollaborationIntroModalProps> = ({
  isOpen,
  onClose,
  onContinue,
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const handleDontShowAgainChange = (value: boolean) => {
    setDontShowAgain(value);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidthClass="max-w-[600px] max-md:max-w-[400px] max-sm:max-w-[350px]"
      showCloseButton={true}
    >
      <div className="p-4">
        <BookCollaborationIntro
          onDontShowAgainChange={handleDontShowAgainChange}
        />
        <div className="flex justify-end mt-4">
          <button
            onClick={() => onContinue(dontShowAgain)}
            className="bg-purple-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-purple-700"
          >
            Got It!
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CollaborationIntroModal;
